import React, { useState } from 'react';
import './AdvancedSearch.css';

const AdvancedSearch = () => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSearch = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await fetch(`http://127.0.0.1:5000/search?q=${encodeURIComponent(query)}`);
            if (!response.ok) {
                throw new Error('Search request failed');
            }
            const data = await response.json();
            setResults(data.results);
        } catch (err) {
            setError('Failed to fetch search results. Please try again.');
            console.error('Search error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="advanced-search">
            <h2>Advanced Search</h2>
            <form onSubmit={handleSearch} className="search-form">
                <div className="search-input-container">
                    <input
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Search relief titles..."
                        className="search-input"
                    />
                    <button type="submit" className="search-button" disabled={isLoading}>
                        {isLoading ? 'Searching...' : 'Search'}
                    </button>
                </div>
            </form>

            {error && <div className="error-message">{error}</div>}

            <div className="search-results">
                {results.length > 0 ? (
                    <>
                        <h3>Search Results ({results.length})</h3>
                        <ul className="results-list">
                            {results.map((relief) => (
                                <li key={relief.id} className="result-item">
                                    <h4>{relief.title}</h4>
                                    <p>Location: {relief.lat}, {relief.lng}</p>
                                </li>
                            ))}
                        </ul>
                    </>
                ) : query && !isLoading && (
                    <p className="no-results">No results found</p>
                )}
            </div>
        </div>
    );
};

export default AdvancedSearch; 